// extracted by mini-css-extract-plugin
module.exports = {"title":"_7a3fb80146--title--ARRNf","row":"_7a3fb80146--row--toLeq","key":"_7a3fb80146--key--aIKBJ","value":"_7a3fb80146--value--BEho1","warning":"_7a3fb80146--warning--nsFvl"};